export default __webpack_public_path__ + "static/IMG_8126-c366186a22bccba4adf40552a5ca6b96.jpeg";